import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, Radio, 
  DatePicker, Select  
} from "antd";
import "antd/dist/antd.css";
import GetHost from "../lib/GetHost";
import pr from "../util/pr";
import axios from "axios";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import {ExclamationCircleOutlined} from '@ant-design/icons';

const {Option} = Select;
const { confirm } = Modal;

const { RangePicker } = DatePicker;

const token = localStorage.getItem("refresh_token"); // 토큰

function PtCouponEdit(props) {
  const { seq, visible, onHideModal, onReload } = props;
  const [data, setData] = useState({});
  const [form] = Form.useForm();

  const handleCancel = () => {
    onHideModal();
  };

  // loadData
  const loadData = async () => {
    let result = await axios.post(GetHost() + "/gympass_admin/pt_coupon_one", {
      seq: seq,
    });
    setData(result.data);
    form.setFieldsValue({    
      seq : result.data.seq,
      use_count: result.data.use_count,
      total_count: result.data.total_count,
      state: result.data.state,
      enroll_date: [
        moment(result.data.enroll_sdate),
        moment(result.data.enroll_edate),
      ],
      pt_type : result.data.pt_type
    });
  };

  useEffect(() => {
    loadData();
  }, [seq]);

  const onConfirm = () => {
    form.submit();
  };

  const onFinish = async ( value ) => {
    let result = axios.post (GetHost()+'/gympass_admin/pt_coupon_update',{
        token:token,
        seq:value.seq,
        enroll_sdate:moment(value.enroll_date[0]).format('YYYY-MM-DD'),
        enroll_edate:moment(value.enroll_date[1]).format('YYYY-MM-DD'),
        use_count: value.use_count,
        total_count: value.total_count,
        state: value.state,
        pt_type:value.pt_type,
    });    
        
    onHideModal();
    onReload();
  }

  const onDelete = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: '삭제하시겠습니까?',
      async onOk() {
          let result = await axios.post(GetHost() + '/gympass_admin/pt_coupon_delete', { 
            seq: seq ,
            token: token
          });
          onReload(); 
      },
      onCancel() {          
      },
  });
  }

  return (
    <Form form={form} onFinish={onFinish}>
      <Modal
        onCancel={handleCancel}
        title="PT/GX 쿠폰"
        visible={visible}
        footer={[
          <Button key="2" type="danger" onClick={onDelete}>
            삭제하기
          </Button>,      
          <Button key="3" type="primary" onClick={onConfirm}>
            수정완료
          </Button>,
        ]}
      >
        <Form.Item name="seq" hidden="true">
            <Input type="text" />
        </Form.Item>

        <Form.Item
          labelCol={{ span: 4 }}
          label="고객명"
          rules={[{ required: false, message: "고객명을 입력해 주세요." }]}
        >
          {data.mb_name}
        </Form.Item>

        <Form.Item
          name="pt_type"
          labelCol={{ span: 4 }}
          label="쿠폰종류"
        >
          <Select style={{ width:100 }}>
            <Option value="PT">PT</Option>
            <Option value="GX">GX</Option>
          </Select>
          
        </Form.Item>        

        <Form.Item label="유효기간" labelCol={{ span: 4 }}>
          <Input.Group compact>
            <Form.Item
              name="enroll_date"
              noStyle
              rules={[{ required: true, message: "필수 항목 입니다." }]}
            >
              <RangePicker locale={locale} />
            </Form.Item>
          </Input.Group>
        </Form.Item>

        <Form.Item label="수량" labelCol={{ span: 4 }}>
          <Input.Group compact>
            <Form.Item
              name="use_count"
              noStyle
              rules={[{ required: true, message: "필수 항목 입니다." }]}
              value={data.use_count}
            >
              <Input
                style={{ width: "20%" }}
                placeholder="사용"
                autoComplete="off"
              />
            </Form.Item>
            <Form.Item
              name="total_count"
              noStyle
              rules={[{ required: true, message: "필수 항목 입니다." }]}
              autoComplete="off"
            >
              <Input
                style={{ width: "20%" }}
                placeholder="보유"
                autoComplete="off"
              />
            </Form.Item>
          </Input.Group>
        </Form.Item>

        <Form.Item
          labelCol={{ span: 4 }}
          name="state"
          label="상태"
          rules={[{ required: false, message: "고객명을 입력해 주세요." }]}
        >
          <Radio.Group>
            <Radio value="Y">예</Radio>
            <Radio value="N">아니오</Radio>
          </Radio.Group>
        </Form.Item>
      </Modal>
    </Form>
  );
}

export default PtCouponEdit;
